import LoginPage, { getDefaultPageData } from "components/pages/LoginPage";
import { BCMSStateManagerCRUD } from "bcms-react";

export default function CaptureLoginPasswordEntered(props) {
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "userID" ], "DemoUser")
        .update([ "password" ], "123456789")
        .submit();

    return <LoginPage data={ data } />
}